import { createContext } from 'react';
import { ItemList } from 'v2/models';

interface CurrentStateFilterContextValue {
  currentState: ItemList;
  setCurrentState: React.Dispatch<React.SetStateAction<ItemList>>;
}

/**
 * prefer using CurrentItemList and useCurrentItemList instead
 * which are equivalent but don't require the using component
 * to call useState
 */
export const CurrentStateFilterContext =
  createContext<CurrentStateFilterContextValue>(
    {} as CurrentStateFilterContextValue
  );
